import { ActivityLogTab } from "@features/ax/shared/ActivityLog";
import { NotesTab } from "@features/ax/shared/NotesTab";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import { useParams } from "react-router-dom";
import { ConditionsRisksTab } from "./ConditionAssessmentTab/AssetConditionTab";
import { AssetDetailsTab } from "./Details/AssetDetailsTab";
import { AssetDocumentsTab } from "./DocumentsTab/AssetDocumentsTab";
import { AssetMaintenanceTab } from "./O&MTab/AssetMaintenanceTab";
import { AssetPerformanceTab } from "./PerformanceTab/AssetPerformanceTab";
import { SchedulesTab } from "./SchedulesTab/scheduleTab";

interface AssetTabsProps {
  data: any;
}

export const AssetTabs: React.FC<AssetTabsProps> = ({ data }) => {
  const source = "1";
  const { id } = useParams();
  const tabComponents = {
    performance: {
      label: "Performance",
      component: <AssetPerformanceTab />,
      shortLabel: "Perf",
    },
    details: {
      label: "Details",
      component: <AssetDetailsTab data={data} />,
      shortLabel: "Details",
    },
    condition: {
      label: "Condition & Risk",
      component: <ConditionsRisksTab data={data} />,
      shortLabel: "Cond",
    },
    schedules: {
      label: "Schedules",
      component: <SchedulesTab />,
      shortLabel: "Sched",
    },
    maintenance: {
      label: "O&M",
      component: <AssetMaintenanceTab data={data} />,
      shortLabel: "O&M",
    },
    documents: {
      label: "Files & Documents",
      component: <AssetDocumentsTab data={data?.uploadedDocuments} />,
      shortLabel: "Docs",
    },
    notes: {
      label: "Notes",
      component: <NotesTab requestId={id} source={source} title="Asset" />,
      shortLabel: "Notes",
    },
    activity: {
      label: "Activity Log",
      component: <ActivityLogTab entityId={id} entityType={source} />,
      shortLabel: "Activity",
    },
  };

  return (
    <div className="w-full">
      <Tabs
        tabComponents={tabComponents}
        defaultValue="performance"
        tabsListClassName="grid w-full grid-cols-8 mb-6"
        tabsListFullWidth
      />
    </div>
  );
};
